import axios from 'axios';
import moment from 'moment/moment';

const ROOT = `api/v1/ssu-patients`;

const PatientStipendApi = {
  getBySitePatientId(ssuPatientId) {
    return axios.get(`${ROOT}/${ssuPatientId}/stipends`, { hideLoader: false });
  },
  getSituationalEncounterInfoBySitePatient(ssuPatientId) {
    return axios.get(`${ROOT}/${ssuPatientId}/stipends/situationals`, { hideLoader: false });
  },
  updateSitePatientEncounterDate(ssuPatientId, sitePatientEncounterId, date) {
    const encounterDate = moment(date).format('YYYY-MM-DD');
    return axios.patch(
      `${ROOT}/${ssuPatientId}/stipends/site-patient-encounters/${sitePatientEncounterId}/dates/${encounterDate}`,
      {},
      { hideLoader: false }
    );
  },
  triggerStipendPayment(ssuPatientId, triggerRequest) {
    return axios.post(`${ROOT}/${ssuPatientId}/stipends/triggers`, triggerRequest, { hideLoader: false });
  }
};

export default PatientStipendApi;
